module.exports = __webpack_public_path__ + "static/demo-thumbnail-84fea7f5ac25d4d5c1ac4737e175e787.png";